import { useDraggable } from '@dnd-kit/core';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { draggable } from './atom.draggable.style.js';
import { GroupTile } from './atom.tile.js';
import { jsx } from 'react/jsx-runtime';

function DraggableTile(props) {
  const isPlacedInDropzone = useOpgavekompleksetEntry({
    select: entry => !!entry?.data.tasks[props.taskEntryKey]?.details[props.tile.id]
  });
  const isDisabled = props.context === "drawer" && isPlacedInDropzone;
  const {
    attributes,
    listeners,
    setNodeRef
  } = useDraggable({
    id: `${props.tile.id}-${props.context}`,
    disabled: isDisabled
  });
  if (isDisabled) {
    return /*#__PURE__*/jsx(GroupTile, {
      ...props,
      state: "placed"
    });
  }
  return /*#__PURE__*/jsx("div", {
    ref: setNodeRef,
    className: draggable,
    "data-is-dragged": props.isDraggingItem,
    style: {
      opacity: props.isDraggingItem ? 0.5 : 1
    },
    ...attributes,
    ...listeners,
    children: /*#__PURE__*/jsx(GroupTile, {
      ...props,
      state: props.state,
      isDraggable: true
    })
  });
}

export { DraggableTile };
//# sourceMappingURL=atom.draggable.js.map
